var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64006 16.0498V8.76932L12.0001 13.0093L18.3601 8.76932V16.0498C18.3601 16.2781 18.14 16.5598 17.7601 16.5598H6.24006C5.86009 16.5598 5.64006 16.2781 5.64006 16.0498Z",
    fill: "#001A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 10.9902L6.67439 7.43977H17.3257L12.0001 10.9902Z",
    fill: "#001A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 24C21.851 24 24 21.851 24 19.2V4.8C24 2.14903 21.851 0 19.2 0H4.8C2.14903 0 0 2.14903 0 4.8V19.2C0 21.851 2.14903 24 4.8 24H19.2ZM3.96006 8.03977C3.96006 6.78056 4.98085 5.75977 6.24006 5.75977H17.7601C19.0193 5.75977 20.0401 6.78056 20.0401 8.03977V16.0498C20.0401 17.3064 18.9641 18.2398 17.7601 18.2398H6.24006C5.03603 18.2398 3.96006 17.3064 3.96006 16.0498V8.03977Z",
    fill: "#001A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaDark);
export default __webpack_public_path__ + "static/media/insta_dark.3683559e9516213afaf35c2db550c1e6.svg";
export { ForwardRef as ReactComponent };